'use strict';

let modalContainer = '';

function customModal() {
	$('[data-modal="true"]').on('click', function (e) {
		e.preventDefault();
		var elementID = $(this).attr('data-modal-id'),
			modal = document.getElementById(elementID);
		customModalOpen(modal);
	});
	$(document).on('click', '.modal-close, .modal-close-outer, .modal-close-btn', function () {
		var modal = $(this).closest('.modal-overlay');
		if ($('.modal-overlay.bonus-sample-selection.error').length > 0) {
			$('.modal-overlay.bonus-sample-selection').removeClass('error');
		}
		customModalClose(modal);
	});
}

function createCustomModalHandler(id, container) {
	var modalStructure = [],
		modal = document.createElement('div');

	modalContainer = container || 'body';
	modal.id = id;
	modal.className = 'modal-overlay ' + id;
	$(modal).html('<div class="modal-close-outer"></div><div class="modal-wrapper"><div class="icon-close modal-close"></div><div class="modal-body"></div></div>');
	modalStructure.push(modal);
	$(modalContainer).append(modalStructure);
	customModalOpen(modal);
	customModalRemove(modal, modalContainer);
}

function customModalOpen(modal) {
	$(modal).show();
	if (modalContainer !== '' || modalContainer === 'body') {
		$('html').addClass('modal-open');
	}
}

function customModalClose(modal) {
	$(modal).hide();
	$('html').removeClass('modal-open');
}

function customModalRemove(modal, container) {
	$(container).on('click', '.modal-close, .modal-close-outer', function () {
		if (!$(this).closest('.modal-overlay').hasClass('data-modal')) {
			$(this).closest('.modal-overlay').remove();
		}
		$('html').removeClass('modal-open');
	});
}

export default {
	modal: () => customModal(),
	createCustomModal: (id, container) => {
		createCustomModalHandler(id, container);
	}
};